// actions/roleActions.js
// BUG FIX: this used a standalone axios instance (cookie-only auth),
// unlike the rest of the app's action files which use createApi() from
// utils/apiClient — that shared client also attaches the JWT as a
// Bearer header from localStorage, which is what makes auth work inside
// Capacitor (mobile) and Electron, where cross-origin cookies are
// unreliable/don't persist. Without it, every call in this file would
// silently 401 on mobile/desktop (web was fine, since cookies work
// there).
import createApi from "../utils/apiClient";
const api = createApi();

export const getAllRoles =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "ALL_ROLES_REQUEST" });
      const { data } = await api.get("/roles", { params });
      dispatch({ type: "ALL_ROLES_SUCCESS", payload: data.roles });
    } catch (err) {
      dispatch({
        type: "ALL_ROLES_FAIL",
        payload: err.response?.data?.message,
      });
    }
  };

// Admin "Pending Approval" tab
export const getPendingRoles = () => async (dispatch) => {
  try {
    dispatch({ type: "PENDING_ROLES_REQUEST" });
    const { data } = await api.get("/roles/pending");
    dispatch({
      type: "PENDING_ROLES_SUCCESS",
      payload: data.roles,
    });
  } catch (err) {
    dispatch({
      type: "PENDING_ROLES_FAIL",
      payload: err.response?.data?.message,
    });
  }
};

export const createRole = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_ROLE_REQUEST" });
    const { data } = await api.post("/roles", payload);
    dispatch({ type: "CREATE_ROLE_SUCCESS", payload: data.role });
    return data;
  } catch (err) {
    dispatch({
      type: "CREATE_ROLE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Called from the Add Staff form's "+ type a new value" option.
// Saves as "pending" — does NOT show up in dropdowns until approved.
export const suggestRole = (name, parent_id) => async (dispatch) => {
  try {
    dispatch({ type: "SUGGEST_ROLE_REQUEST" });
    const { data } = await api.post("/roles/suggest", { name, parent_id });
    dispatch({ type: "SUGGEST_ROLE_SUCCESS", payload: data.role });
    return data;
  } catch (err) {
    dispatch({
      type: "SUGGEST_ROLE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const approveRole = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/roles/${id}/approve`);
    dispatch({ type: "APPROVE_ROLE_SUCCESS", payload: data.role });
    return data;
  } catch (err) {
    dispatch({
      type: "APPROVE_ROLE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const rejectRole = (id, reason) => async (dispatch) => {
  try {
    const { data } = await api.put(`/roles/${id}/reject`, { reason });
    dispatch({ type: "REJECT_ROLE_SUCCESS", payload: data.role });
    return data;
  } catch (err) {
    dispatch({
      type: "REJECT_ROLE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const updateRole = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_ROLE_REQUEST" });
    const { data } = await api.put(`/roles/${id}`, payload);
    dispatch({ type: "UPDATE_ROLE_SUCCESS", payload: data.role });
    return data;
  } catch (err) {
    dispatch({
      type: "UPDATE_ROLE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const deleteRole = (id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_ROLE_REQUEST" });
    const { data } = await api.delete(`/roles/${id}`);
    dispatch({ type: "DELETE_ROLE_SUCCESS", payload: id });
    return data;
  } catch (err) {
    dispatch({
      type: "DELETE_ROLE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// A rejected entry can be resubmitted — resets it back to "pending" so it
// shows up in the Approvals queue again.
export const resubmitRole = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/roles/${id}/resubmit`);
    dispatch({ type: "RESUBMIT_ROLE_SUCCESS", payload: data.role });
    return data;
  } catch (err) {
    dispatch({
      type: "RESUBMIT_ROLE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Rejected list — shown on the Approvals page so admin/requester can
// review the reason and Resubmit if needed. Stored separately from the
// active dropdown list (state.role.rejected) to avoid clobbering it.
export const getRejectedRoles = () => async (dispatch) => {
  try {
    const { data } = await api.get("/roles", {
      params: { status: "rejected" },
    });
    dispatch({ type: "REJECTED_ROLES_SUCCESS", payload: data.roles });
  } catch (err) {
    dispatch({
      type: "REJECTED_ROLES_FAIL",
      payload: err.response?.data?.message,
    });
  }
};
